<div class="flex flex-row place-content-center items-start">
  <div class="flex flex-col w-full max-w-screen-2xl pt-8">
    <h1 class="text-white pl-10">Settings</h1>
    <div *ngIf="authenticatedUser$ | async as authenticatedUser" class="bg-white rounded-xl m-6">
      <quorum-marketing-store-settings [custId]="authenticatedUser.user.destination">
      </quorum-marketing-store-settings>
    </div>
  </div>
</div>